/**
 * Escapes special characters in field names
 *
 * @param fieldName The name to escape.
 * @returns The escaped name.
 */
export function escapeFieldName(fieldName) {
    return fieldName.replace(/\./g, "\\.");
}
const levelSplitter = /(?<!\\)\./g;
/**
 * Splits a field path into its segments
 *
 * @param fieldPath The field path to split
 * @returns The split path.
 */
export function splitPath(fieldPath) {
    return fieldPath.split(levelSplitter);
}
//# sourceMappingURL=objectPaths.js.map